import type { UIPayment, UIPayout } from '../../store/formatters';

export const PAYMENT_EMPTY_DATA: UIPayment = {
  tax: undefined,
  methodsTypes: [],
  isReady: false,
  canAutoRedirect: true,
  isRequestPending: false,
  submitPaymentReady: false,
  currencyId: undefined,
  currencyAlpha3: undefined,
  widgetSettings: {
    country_filtering_enabled: false,
  },
  growthbookFeatures: undefined,
  methods: [],
  carouselMethodList: [],
  methodToRedirect: undefined,
  viewData: [],
  withdrawalReverse: undefined,
  pendingWithdrawals: [],
  merchantUrl: undefined,
  merchantSuccessUrl: undefined,
  merchantFailUrl: undefined,
  merchantProcessingUrl: undefined,
  merchantRedirectType: undefined,
  userBonuses: null,
  userBalance: 0,
  authToken: '',
  merchantApiKey: '',
  paygroupCategories: undefined,
  walletCurrencies: [],
  shouldSkipInitFeature: false,
  selectedCurrency: null,
  userCurrency: null,
  userBlocked: false,
  defaultFiatCurrency: null,
  meshMethods: [],
};

export const PAYOUT_EMPTY_DATA: UIPayout = {
  tax: undefined,
  methodsTypes: [],
  isReady: false,
  canAutoRedirect: true,
  isRequestPending: false,
  submitPaymentReady: false,
  currencyId: undefined,
  currencyAlpha3: undefined,
  widgetSettings: {
    country_filtering_enabled: false,
  },
  methods: [],
  lastDeclineInfo: null,
  carouselMethodList: [],
  methodToRedirect: undefined,
  viewData: [],
  merchantUrl: undefined,
  merchantSuccessUrl: undefined,
  merchantFailUrl: undefined,
  merchantProcessingUrl: undefined,
  merchantRedirectType: undefined,
  userBalance: 0,
  growthbookFeatures: undefined,
  authToken: '',
  merchantApiKey: '',
  paygroupCategories: undefined,
  walletCurrencies: [],
  shouldSkipInitFeature: false,
  selectedCurrency: null,
  userCurrency: null,
  userBlocked: false,
  defaultFiatCurrency: null,
  meshMethods: [],
};
